import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GetOrders from "../api/GetOrders";
import logo from "../../../asset/images/Rizik-Arb-logo.png";
import formatDate from "../../../utils/FormatDate";

const OrderDetail = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [mapUrl, setMapUrl] = useState("");

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number);
  };

  useEffect(() => {
    const getOrderData = async () => {
      let orders = await GetOrders();
      let order_item = orders.filter((order) => order.orderId.toString() === orderId);
      setOrder(order_item[0]);
      setOrderItems(order_item[0].items);
    };
    getOrderData();
  }, [orderId]);

  useEffect(() => {
    if (order.location) {
      const [latitude, longitude] = order.location.split(",");
      setMapUrl(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`);
    }
    console.log(order);
  }, [order.location]);

  const handlePrint = () => {
    // Trigger the browser's print functionality
    window.print();
  };

  return (
    <>
      <div className="p-4 ">
        <div className="bg-white p-4 rounded-lg flex flex-col items-center">
          {/* Order details */}
          <h2 className="text-xl font-bold mb-4">طلبية رقم #{order.orderId}</h2>
          <div className="w-full h-60">
            <img src={logo} alt="Company Logo" className="w-full h-full object-contain" />
          </div>
          <div className="w-full flex flex-wrap flex-row-reverse items-end justify-end">
            {/* Order Owner Name */}
            <div className="mb-4 px-4 w-1/2 flex items-end flex-col">
              <label className="block text-sm font-medium text-gray-700">اسم صاحب الطلب</label>
              <input
                type="text"
                value={order.name || ""}
                className="mt-1 p-2 w-full bg-gray-100 rounded-lg border border-gray-300 focus:outline-none focus:border-blue-400 "
                disabled
                dir="rtl"
              />
            </div>
            {/* Order Date */}
            <div className="mb-4  px-4  w-1/2 flex items-end flex-col">
              <label className="block text-sm font-medium text-gray-700">تاريخ الطلب</label>
              <input
                type="text"
                value={formatDate(order.orderdate) || ""}
                className="mt-1 p-2 w-full bg-gray-100 rounded-lg border border-gray-300 focus:outline-none focus:border-blue-400"
                disabled
                dir="rtl"
              />
            </div>
            <div className="mb-4 px-4 w-1/2 flex items-end flex-col">
              <label className="block text-sm font-medium text-gray-700">عنوان صاحب الطلب</label>
              {/* Replace the input with a div styled like an input */}
              <div
                className="mt-1 p-2 w-full bg-gray-100 rounded-lg border border-gray-300 focus:outline-none focus:border-blue-400 flex items-center justify-between"
                dir="rtl"
              >
                {mapUrl && (
                  <a
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline ml-2 text-center"
                  >
                    فتح الموقع على خرائط جوجل
                  </a>
                )}
              </div>
            </div>
            <div className="mb-4  px-4  w-1/2 flex items-end flex-col">
              <label className="block text-sm font-medium text-gray-700">رقم هاتف العميل</label>
              <a
                href={`tel:${order.phone}`}
                className="mt-1 p-2 w-full bg-gray-100 rounded-lg border border-gray-300 focus:outline-none  block text-blue-500 underline ml-2 text-right"
              >
                {order.phone || ""}
              </a>
            </div>
            <div className="mb-4 px-4 w-1/2 flex items-end flex-col">
              <label className="block text-sm font-bold text-red-700">
                المبلغ الإجمالي (بالدينار العراقي):
              </label>
              <input
                type="text"
                value={formatNumber(order.totalIraqiprice)}
                className="mt-1 p-2 w-full bg-red-700 rounded-lg font-mono text-gray-100 font-bold border border-gray-300 focus:outline-none focus:border-blue-400 "
                disabled
                dir="rtl"
              />
            </div>
            <div className="mb-4  px-4  w-1/2 flex items-end flex-col">
              <label className="block text-sm font-medium text-gray-700">المنطقة:</label>
              <input
                type="text"
                value={order.regionNameAr}
                className="mt-1 p-2 w-full bg-gray-100 rounded-lg border border-gray-300 focus:outline-none focus:border-blue-400"
                disabled
                dir="rtl"
              />
            </div>
          </div>

          <table className="w-full mt-4">
            <thead>
              <tr>
                <th className="border border-gray-400 p-2">مجموع</th>
                <th className="border border-gray-400 p-2">الكمية</th>
                <th className="border border-gray-400 p-2">(بالعراقي)السعر</th>
                <th className="border border-gray-400 p-2">اسم المادة</th>
              </tr>
            </thead>
            <tbody>
              {orderItems.map((item) => {
                return (
                  <tr>
                    <td className="border border-gray-400 p-2 text-center">
                      {formatNumber(item.qty * item.itemsIRAQIprice)}
                    </td>
                    <td className="border border-gray-400 p-2 text-center">{item.qty}</td>
                    <td className="border border-gray-400 p-2 text-center">
                      {formatNumber(item.itemsIRAQIprice)}
                    </td>
                    <td className="border border-gray-400 p-2 text-center">{item.itemsName}</td>
                  </tr>
                );
              })}

              {/* Add more rows for other items */}
            </tbody>
          </table>
        </div>
        <button
          onClick={handlePrint}
          className="bg-blue-500 text-white px-4 py-2 mt-4 print:hidden "
        >
          طباعة
        </button>
      </div>
    </>
  );
};

export default OrderDetail;
